<!--
 * @Author: lan.h
 * @Date: 2022-02-14 16:45:55
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-23 11:54:28
 * @Description: 报告
-->
<template>
  <div>
    <div class="report">
      <div class="report-item" v-for="a,idx in report" :key="a.uid">
          <div class="spc_img top-imgs" @click.stop="toReport(a)">
            <div class="img">
              <i class="iconfont collect-icon active" title="取消收藏" v-if="a.isCollect" @click.stop="cancelCollect('1', a.id, delCollectCb, idx)">&#xe66f;</i>
              <i class="iconfont collect-icon" title="收藏" v-else @click.stop="addCollect('1', a.id, addCollectCb, idx)">&#xe66f;</i>
              <img :src="a.logoPath | logo_show"/>
            </div>
            <div class="icon_column">报告</div>
            <div class="core"></div>
          </div>
          <div class="bottom-content">
              <a :href="$store.state.index_path + '/reportDetail/' + a.uid"  target="_blank" class="h1 over-p2">{{a.title}}</a>
              <div class="re-line">
                <div></div>
                <div>相关赛道</div>
              </div>
              <div class="tags1">
                <a v-for="t, index in a.tracks" :key="index" v-if="index < 3" @click="toTrack(t)">{{t | dealNeed(entityNtag)}}</a>
              </div>
          </div>
      </div>
    </div>
    <div class="flash-more1" @click="toReportList">
      <a>查看更多报告</a>
    </div>
  </div>
</template>

<script>
import { collect_mixin } from "js/collect_mixin";
export default {
  mixins: [collect_mixin],
  props: ['report', 'entityNtag'],
  data() {
    return {
    }
  },
  methods: {
    addCollectCb(idx) {
      this.report[idx].isCollect = true
    },
    delCollectCb(idx) {
      this.report[idx].isCollect = false
    },
    toReport(a) {
      const href = this.$store.state.index_path + '/reportDetail/' + a.uid
      window.open(href, '_blank')
    },
    toTrack(tag) {
      const href = this.$store.state.index_path + '/trackDetail?tag=' + tag
      window.open(href, '_blank')
    },
    toReportList() {
      const href = this.$store.state.index_path + '/reportingDetail'
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
.report
  display flex
  justify-content space-between
  &-item
    position relative
    width 246px
    background #FFFFFF
    .top-imgs
      width 230px
      height 147px
      display flex
      position relative
      cursor pointer
      .img
        overflow hidden
        position relative
        width 100%
        height 100%
        .collect-icon
          position absolute
          top 10px
          right 10px
          width 18px
          height 18px
          text-align center
          line-height 18px
          color #ccc
          background-color #f3f3f3
          border-radius 2px
          font-size 10px
          z-index 4
          display inline-block
          cursor pointer
          &:hover
          &.active
            color #fff
            background rgba(250, 122, 80, 1)
        img
          width 100%
          height 100%
          transition all .4s
          &:hover
            transform scale(1.1)
            transition all 0.6s ease 0s
      .core
        width 0
        height 0
        border-style solid
        border-color #E3E3E3 transparent
        border-width 0 16px 12px 0
        position absolute
        bottom 0
        right -16px
    &:hover 
      .cover-img 
        img
          transform: scale(1.1)
    .bottom-content
      height 150px
      background #FFFFFF
      box-shadow 0px 10px 30px 0px rgba(121, 133, 143, 0.1)
      padding 10px 20px 10px 20px
      position relative
      .h1 
        font-size 14px
        font-weight 500
        color #333333
        line-height 20px
        height 36px
        transition all .5s
        cursor pointer
        &:hover 
          color #FF8824
      .re-line
        font-size 12px
        font-weight 500
        color #999999
        line-height 18px
        margin-top 10px 
        display flex 
        justify-content space-between
        align-items center
        >div:nth-child(1)
          height 1
          width 97px
          height 1px
          background #DDDDDD
      .tags1
        position absolute
        bottom 14px
        left 20px
        overflow hidden
        width calc(100% - 40px)
        a 
          background #FFF8F1
          border-radius 13px
          font-size 12px
          font-family PingFang SC
          font-weight 400
          color #FF8824
          line-height 1
          padding 6px 8px
          display inline-block
          margin-right 10px
          margin-top 8px
          transition all .5s
          &:last-child
            margin-right 0
          &:hover 
            background #FF8824
            color #fff
.flash-more1
  margin-top 20px
  font-size 12px
  height 26px
  line-height 24px
  border 1px solid rgba(255, 230, 207, .6)
  text-align center
  cursor pointer
  transition all 0.5s
  &:hover
    border-color #FF6600
    a
      color #FF6600
</style>